const model = {
  p_id: '',
  id: '',
  timestamp: '',
  i_injuries: '',
  i_cash: '',
  i_condoms: '',
  i_hotel_keys: '',
  i_manicures: '',
  i_unrelated_adult: '',
  i_sleep_deprivation: '',
  // i_intoxication: '',
  // i_changing_demographic: '',
  i_showing_deference: '',
  i_speaks_for_them: '',
  // i_false_age: '',
  i_withholds_demographic: '',
  i_no_eye_contact: '',
  i_drug_alcohol_use: '',
  i_anxious: '',
  // i_fearful_of_others: '',
  i_contraception: '',
  i_moves_around: '',
  i_memory_gaps: '',
  i_fearful: '',
  i_no_identification: '',
  i_trouble_speaking: '',
  i_multiple_pregancies: '',
  i_expensive_items: '',
  i_the_life_language: '',
  i_manner_of_dress: '',
  i_multiple_phones: '',
  i_tattoos: '',
  i_savvy: '',
  i_lack_of_care: '',
  i_suicidal_ideation: '',
  i_runaway: '',
  i_scripted: '',
  i_hyperarousal: '',
  i_sti: '',
  i_truancy: '',
  i_history_abuse: '',
  q_safe: '',
  d_safe: '',
  q_doctor: '',
  d_doctor: '',
  q_anybody: '',
  d_anybody: '',
  q_finding: '',
  d_finding: '',
  q_someone_else: '',
  d_someone_else: '',
  q_do_something: '',
  d_do_something: '',
  q_bullied: '',
  d_bullied: '',
  d_could_not_leave: '',
  d_basic_needs: '',
  d_school: '',
  d_worst_hurt: '',
  d_hang_out: '',
  q_someone_else_det: '',
  dmst_conclusion: '',
  i_flat_affect: '',
  i_self_injury: '',
  i_assault: '',
  i_poor_dentition: '',
  location: '',
  program: ''

}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/assessment.js